import React from 'react';
import styles from './tvstickybutton.module.css';
import clsx from 'clsx';

interface TVStickyButtonProps {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  contextualText?: string;
}

const TVStickyButton: React.FC<TVStickyButtonProps> = ({
  label,
  onClick,
  disabled = false,
  className,
  contextualText,
}) => {
  const renderContextualText = () => {
    if (!contextualText) return null;

    // Parse the text to extract name and rest
    // Format: "{name} from {location} took FREE trial 🎉"
    const match = contextualText.match(/^(.+?)\s+(from.+)$/);
    
    if (match) {
      const name = match[1];
      const rest = match[2];
      
      return (
        <div className={styles.contextualText}>
          <span className={styles.nameGradient}>{name}</span>
          <span className={styles.restText}> {rest}</span>
        </div>
      );
    }
    
    // Fallback if pattern doesn't match
    return (
      <div className={styles.contextualText}>
        <span className={styles.restText}>{contextualText}</span>
      </div>
    );
  };

  return (
    <div className={clsx(styles.stickyButtonContainer, className)}>
      {renderContextualText()}
      <button
        className={clsx(styles.stickyButton, disabled && styles.disabled)}
        onClick={onClick}
        disabled={disabled}
      >
        {label}
      </button>
    </div>
  );
};

export default TVStickyButton;

